import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\GetSupplierListController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierListController.php
* @route '/api/supplier'
*/
const GetSupplierListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierListController.url(options),
    method: 'get',
})

GetSupplierListController.definition = {
    methods: ["get","head"],
    url: '/api/supplier',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Supplier\GetSupplierListController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierListController.php
* @route '/api/supplier'
*/
GetSupplierListController.url = (options?: RouteQueryOptions) => {
    return GetSupplierListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\GetSupplierListController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierListController.php
* @route '/api/supplier'
*/
GetSupplierListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Supplier\GetSupplierListController::__invoke
* @see app/Http/Controllers/Supplier/GetSupplierListController.php
* @route '/api/supplier'
*/
GetSupplierListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSupplierListController.url(options),
    method: 'head',
})

export default GetSupplierListController